import { render, staticRenderFns } from "./ArticleContent.vue?vue&type=template&id=97414bca&scoped=true"
import script from "./ArticleContent.vue?vue&type=script&lang=js"
export * from "./ArticleContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97414bca",
  null
  
)

export default component.exports